import type { UserStandard } from '@/shared/hooks/api/userStandards'

/** Props shared by scope, hazards, RRMs, and information-for-use sections on standard detail. */
export type StandardDetailSectionProps = {
  standard: UserStandard
  hasPdf: boolean
  isPdfUploading: boolean
  onUploadPdf: () => void
}

export function userStandardHasPdf(
  standard: Pick<UserStandard, 'fileName' | 'filePathInBucket'> | null | undefined
): boolean {
  if (standard == null) {
    return false
  }
  return Boolean(standard.fileName) || Boolean(standard.filePathInBucket)
}
